export class PasswordModel {
    oldPassword!: string;
    newPassword!: string;
    confirmPassword!: string;

    public constructor(init?:Partial<PasswordModel>) {
        Object.assign(this, init);
    }
}
